import script from "./InventoryProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryProfile.vue?vue&type=script&setup=true&lang=js"

import "./InventoryProfile.vue?vue&type=style&index=0&id=5428ae45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5428ae45"]])

export default __exports__